<template>
  <Icon>
    <svg slot="svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="icons/check_yes" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
        <circle id="Oval" fill="#43CEA2" cx="12" cy="12" r="10"></circle>
        <g id="checkmark" transform="translate(6.000000, 7.000000)" fill="#FFFFFF">
          <path d="M11.551273,0.470101903 C10.9529704,-0.156700634 9.98330754,-0.156700634 9.38500492,0.470101903 L3.96877198,6.13055182 L2.61499508,4.71543934 C2.01669246,4.09248221 1.04665448,4.09248221 0.448726966,4.71543934 C-0.149575655,5.34224188 -0.149575655,6.35743126 0.448726966,6.98038839 L2.88582548,9.5298981 C3.4841281,10.1567006 4.45379097,10.1567006 5.05209359,9.5298981 L11.551273,2.73505095 C12.1495757,2.10824841 12.1495757,1.09305903 11.551273,0.470101903" id="Shape"></path>
        </g>
      </g>
  </svg>
  </Icon>
</template>

<script>
import Icon from './icon';

export default {
  name: 'DsConfirmedIcon',
  components: {
    Icon
  }
};
</script>


// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-confirmed-icon.vue